import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadAnalyticsService {
  private platformId = inject(PLATFORM_ID);

  loadAnalytics() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (typeof window === 'undefined' || typeof document === 'undefined')
      return;

    try {
      // Google Analytics (GTAG)
      const gaId = 'G-ESSE0CC9C6';
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(gaScript);

      const win = window as any;
      win.dataLayer = win.dataLayer || [];
      win.gtag = function () {
        win.dataLayer.push(arguments);
      };

      win.gtag('js', new Date());
      win.gtag('config', gaId, { send_page_view: false });
    } catch (error) {
      console.error('GA Load Fail:', error);
    }

    // Meta Pixel logic can be added here if needed in the future
  }
}
